import * as React from "react";
import Box from "@mui/material/Box";

import FormControl from "@mui/material/FormControl";
import TextField from '@mui/material/TextField';
export default function InputTextField(props) {
  const {label, name, onChange, type, value , readOnly, disabled, onKeyPress} = props;
  
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", width:"100%" }}>
      <FormControl fullWidth sx={{  }} variant="standard">
      <TextField
          id="outlined-basic"
          size="small"
          label={value ? '' : label}
          variant="outlined"
          min="0"
          max="2"
          value={value}
          type={type ? type : "text"}
          name={name} 
          onChange={onChange} 
          readOnly={readOnly ? true : false}
          disabled={disabled}
          inputProps={type == 'file' ? {accept:".png, .jpg, .jpeg, .svg"}: {}}
          onKeyPress = {onKeyPress}
        />
        {/* <InputLabel htmlFor="standard-adornment-amount">{lable}</InputLabel>
        <Input id="standard-adornment-amount" value={value} type={type ? type : "text"} name={name} onChange={onChange} readOnly={readOnly ? true : false} /> */}
      </FormControl>
    </Box>
  );
}
